/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
import type { Breakpoints } from '../types';
const breakpoints: Breakpoints = {
  small: 320,
  medium: 600,
  large: 1136
};
export default breakpoints;